import React from "react";
import PageTitle from "../Dashboard/PageTitle";
import "../Dashboard/main.css";
import ScreenContainer from "./Screencontainer";

function Screenmain() {
  return (
    <main id="main" className="main">
      <PageTitle page={"Screener"} />
      <ScreenContainer />
    </main>
  );
}

export default Screenmain;
